import {BaseCommandMessage, BaseResponseMessage} from "./base";
import {Funnel} from "../funnel";

export interface TelegramStarsPackageDto {
    /**
     * Идентификатор пакета — чистая функция от его содержимого ("<stars>-<moneyCents>").
     * Правка цены в конфиге меняет идентификатор, поэтому оплатить по устаревшему нельзя.
     */
    packageId: string,
    moneyCents: number,
    stars: number
}

/**
 * Список пакетов пополнения. Берётся свежим при открытии диалога, а не из ExtraInfo: у долгой
 * сессии список из момента входа успевает протухнуть. См. `docs/specs/telegram-stars-topup.md` §5.
 */
export namespace GetTelegramStarsPackagesCommandNamespace {
    export const COMMAND = 'get_telegram_stars_packages';

    export class Request extends BaseCommandMessage {
        constructor() {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly packages: TelegramStarsPackageDto[]) {
            super(COMMAND, id, true);
        }
    }
}

/**
 * Создать намерение оплаты и получить ссылку на бота.
 *
 * Логин берётся из аутентифицированной WS-сессии, а сумма и цена замораживаются в намерении —
 * поэтому ни привязка Telegram-аккаунта, ни доверие к данным бота не нужны.
 * См. `docs/specs/telegram-stars-topup.md` §5.
 */
export namespace CreateTelegramStarsPaymentCommandNamespace {
    export const COMMAND = 'create_telegram_stars_payment';

    export class Request extends BaseCommandMessage {
        constructor(readonly packageId: string, readonly source?: Funnel.Source, readonly flow?: Funnel.Flow) {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly botDeepLink: string) {
            super(COMMAND, id, true);
        }
    }
}
